<template>
    <div class="freight">

        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="freight_content">
            <div class="freight_content_gooList" v-for="item in freightListData.skus" :key="item.id">
                <div class="freight_content_gooList_img"><img v-lazy="$viewImageNew(item.productPictureUrl, 400,400)" alt=""></div>
                <div class="freight_content_gooList_right">
                    <h3 v-text="item.productName"></h3>
                    <div class="freight_content_gooList_right_bottom">
                        <div class="freight_content_gooList_right_bottom_left"><span class="price"><sub>￥</sub>{{ item.price | NumFormat }}</span></div>
                        <div class="freight_content_gooList_right_bottom_price" v-if="item.singleFreight">运费：<span><sub>￥</sub>{{ item.singleFreight | NumFormat }} x {{item.quantity}}</span></div>
                        <div class="freight_content_gooList_right_bottom_price" v-else>运费：<span>待运营维护</span></div>
                    </div>
                </div>
            </div>
            <div class="freight_detail">
                <div class="freight_detail_item" style="padding-bottom:5px">
                    <div class="freight_detail_title">运费合计</div>
                    <div class="freight_detail_price"><sub>￥</sub>{{freightListData.totalAmount | NumFormat}}</div>
                </div>
                <div class="freight_detail_item">
                    <div class="freight_detail_title">运费优惠</div>
                    <div class="freight_detail_price" v-if="freightListData.discountAmount<0">
                        -<sub>￥</sub>{{Math.abs(freightListData.discountAmount) | NumFormat}}
                    </div>
                    <div class="freight_detail_price" v-else>
                        <sub>￥</sub>{{freightListData.discountAmount | NumFormat}}
                    </div>
                </div>
            </div>
        </div>
        <div class="freight_foot">
            <div class="freight_foot_left" v-if="freightListData.finalTotalAmount!==null || freightListData.actualAmount!==null">实付运费：<span class="freight_colFF7A45"><sub>￥</sub>{{ (freightListData.finalTotalAmount || freightListData.actualAmount) | NumFormat }}</span></div>
            <div class="freight_foot_left" v-else>实付运费：<span class="freight_colFF7A45">待运营维护</span></div>
            <div class="freight_foot_right" @click="onOpen()"> <span class="freight_colFF7A45">《运费服务说明》</span></div>
        </div>
        <FreightServer :visible.sync='popupFreightServer' v-if="popupFreightServer" />
    </div>
</template>
<script>
import FreightServer from './component/freightServer'
import Head from '../../common/head'
import { getFreightDetail } from '../api/order'
export default {
    name: 'freightDetails',
    props: {
        freightInfoData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {
        Head,
        FreightServer
    },
    methods: {
        onBack () {
            if (this.$route.query.id) {
                this.$router.back(-1)
            } else {
                this.$emit('getFreightBack')
            }
        },
        onOpen () {
            this.popupFreightServer = !this.popupFreightServer
        },
        async freightData () {
            const { data } = await getFreightDetail({
                id: this.$route.query.id,
                deliveryOrderId: this.$route.query.deliveryOrderId
            })
            this.freightListData = data
        }
    },
    data () {
        return {
            headInfo: {
                title: '运费明细'
            },
            popupFreightServer: false,
            freightListData: {}
        }
    },
    mounted () {
        if (this.$route.query.id) {
            this.freightData()
        } else {
            this.freightListData = this.freightInfoData
        }
    }
}
</script>
<style lang="scss" scoped>
.freight {
    height: 100%;
    overflow: hidden;
    &_content {
        background: #f5f5f5;
        overflow: auto;
        height: calc(100% - 220px);
        &_gooList {
            background: #fff;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            padding: 32px 34px;
            &_img {
                width: 184px;
                height: 184px;
                position: relative;
                display: flex;
                background: #f5f5f5;
                img {
                    display: inline-block;
                    align-self: center;
                    justify-self: center;
                    margin: 0 auto;
                    object-fit: cover;
                }
            }
            &_right {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                align-content: space-between;
                padding-left: 24px;
                h3 {
                    width: 100%;
                    color: #333;
                    font-size: 28px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
                &_bottom {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    &_left {
                        font-size: 20px;
                        span {
                            font-size: 26px;
                        }
                    }
                    &_price {
                        font-size: 26px;
                        color: #000000;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        padding-right: 8px;
                        sub {
                            font-size: 20px;
                        }
                        span {
                            font-size: 30px;
                        }
                    }
                }
            }
        }
    }
    &_foot {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 32px 32px 56px;
        &_left {
            font-size: 30px;
            sub {
                font-size: 20px;
            }
        }
        &_right {
            font-size: 26px;
        }
    }
    &_colFF7A45 {
        color: #ff7a45;
    }
    .price{
        font-size: 30px;
        sub {
            font-size: 20px;
        }
    }
    .freight_detail{
        background: #fff;
        padding: 28px 34px;
        border-top:1px solid #d1d1d6;
    }
    .freight_detail_item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 28px;
        color: #333;
        sub {
            font-size: 20px;
        }
    }
}
</style>
